import { render, staticRenderFns } from "./PermissionFormModal.vue?vue&type=template&id=4133d776&scoped=true"
import script from "./PermissionFormModal.vue?vue&type=script&lang=js"
export * from "./PermissionFormModal.vue?vue&type=script&lang=js"
import style0 from "./PermissionFormModal.vue?vue&type=style&index=0&id=4133d776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133d776",
  null
  
)

export default component.exports